import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-65168e11")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _directive_loading = _resolveDirective("loading")

  return _withDirectives((_openBlock(), _createBlock(_component_el_table, {
    ref: "table",
    "element-loading-text": _ctx.loadingText,
    data: _ctx.tableData,
    border: _ctx.border,
    "row-key": _ctx.rowKey,
    "empty-text": _ctx.emptyText,
    onSelectionChange: _ctx.selectionChange,
    onRowClick: _ctx.rowClick,
    height: _ctx.height
  }, {
    default: _withId(() => [
      (_ctx.isSelection)
        ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            type: "selection",
            align: _ctx.align
          }, null, 8, ["align"]))
        : _createCommentVNode("", true),
      (_ctx.showIndex)
        ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 1,
            label: "序号",
            type: "index",
            width: "60px",
            align: _ctx.align
          }, null, 8, ["align"]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.column, (item) => {
        return (_openBlock(), _createBlock(_component_el_table_column, {
          key: item.label,
          prop: item.prop,
          label: item.label,
          fixed: item.fixed,
          align: item.align ? item.align : _ctx.align
        }, _createSlots({ _: 2 }, [
          (!item.children)
            ? {
                name: "default",
                fn: _withId((scope) => [
                  _renderSlot(_ctx.$slots, item.prop, {}, () => [
                    _createTextVNode(_toDisplayString(scope.row[(item.prop) as string]), 1)
                  ])
                ])
              }
            : undefined
        ]), 1032, ["prop", "label", "fixed", "align"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["element-loading-text", "data", "border", "row-key", "empty-text", "onSelectionChange", "onRowClick", "height"])), [
    [_directive_loading, _ctx.loading]
  ])
})